import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    createCompanyAgreement,
    updateCompanyAgreement,
    fetchCompanyAgreement,
    fetchCompanyAgreementDetail,
    generatePdf
} from "./actions/index";
import {
    Row,
    Spin
} from "antd";
import AgreementForm from "./forms/agreement-form";
import "styles/agreement-tab.css";
import CompanyLosService from "./services/company-los-services";
class AgreementPage extends React.Component {

    state = {
        agreementMasterList: null,
        formValues: null,
        masterType: null
    };

    componentDidMount() {
        CompanyLosService.getAgreementDocumentMasterList().then(_ => {
            this.setState({
                agreementMasterList: _.data.results.map(_ => ({
                    ..._,
                    name: _.name + " | " + _.description,
                }))
            }, () => {
                this.agreementMaster = this.state.agreementMasterList;
                this.props.fetchCompanyAgreement(this.props.companyId);
                this.props.fetchCompanyAgreementDetail(this.props.companyId);
            });
        });
    }

    fetchCompanyAgreementDetail = () => {
        this.props.fetchCompanyAgreementDetail(this.props.companyId);
    }

    onSubmit = (values) => {
        if(this.props.companyAgreement && this.props.companyAgreement.id) {
            this.props.updateCompanyAgreement(this.props.companyId, {...values, id: this.props.companyAgreement.id});
        } else {
            this.props.createCompanyAgreement(this.props.companyId, values);
        }
        // this.setState({
        //     formValues: agreementDetail,
        //     masterType: masterVal
        // }, () => {
            
        // });
    }

    fetchAgreementDetail = () => {
        this.props.fetchCompanyAgreementDetail(this.props.companyId);
    }

    onGeneratePdf = (values) => {
        this.props.generatePdf(this.props.companyId, values);
    }

    render() {
        return (
            <Row style={{
                height: "100vh"
            }}>
                <Spin spinning={this.props.companyAgreementStatus === "FETCHING"}>
                    <AgreementForm
                        agreementMasterList={this.state.agreementMasterList || this.agreementMaster}
                        agreementValues={this.props.companyAgreement}
                        onSubmit={this.onSubmit}
                        masterType={this.state.masterType}
                        companyDetails={this.props.companyDetails}
                        agreementDetail={this.props.agreementDetail}
                        generatePdf={this.onGeneratePdf}
                        fetchAgreementDetail={this.fetchAgreementDetail}
                        fetchCompanyAgreementDetail={this.fetchCompanyAgreementDetail}
                        companyId={this.props.companyId}
                    />
                </Spin>
            </Row>
        );
    }
}

AgreementPage.propTypes = {
    companyId: PropTypes.number,
    createCompanyAgreement: PropTypes.func,
    updateCompanyAgreement: PropTypes.func,
    fetchCompanyAgreement: PropTypes.func,
    companyAgreement: PropTypes.object,
    companyAgreementStatus: PropTypes.string,
    companyDetails: PropTypes.object,
    fetchCompanyAgreementDetail: PropTypes.func,
    agreementDetail: PropTypes.object,
    generatePdf: PropTypes.func
};

const mapStateToProps = (state, props) => ({
    companyAgreementStatus: state.companyLosProfiles.getIn(["agreement", props.companyId, "status"]),
    companyAgreement: state.companyLosProfiles.getIn(["agreement", props.companyId, "data"]),
    companyDetails: state.companyLosProfiles.getIn(["profiles", props.companyId, "data"]),
    agreementDetail: state.companyLosProfiles.getIn(["agreementDetail", props.companyId, "data"])
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        createCompanyAgreement,
        updateCompanyAgreement,
        fetchCompanyAgreement,
        fetchCompanyAgreementDetail,
        generatePdf
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps) (AgreementPage);